var render, staticRenderFns
import script from "./interface_parameters.vue?vue&type=script&lang=js"
export * from "./interface_parameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a549df2')) {
      api.createRecord('1a549df2', component.options)
    } else {
      api.reload('1a549df2', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/backstage_manage/interface_parameters/interface_parameters.vue"
export default component.exports